// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-netzsync {
  padding: 4rem 0;
  background: #f8fafc;
}

.why-netzsync-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.why-netzsync-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  color: #1e293b;
  margin-bottom: 3rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: white;
  padding: 2rem;
  border-radius: 0.75rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: box-shadow 0.3s ease;
}

.feature-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  width: 4rem;
  height: 4rem;
  background: #2563eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  color: white;
  font-size: 1.5rem;
}

.feature-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
}

.feature-description {
  color: #64748b;
  line-height: 1.6;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .why-netzsync {
    padding: 3rem 0;
  }

  .why-netzsync-title {
    font-size: 2rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .feature-card {
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuestPage/Why-netz-sync/WhyNetzSync.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".why-netzsync {\n  padding: 4rem 0;\n  background: #f8fafc;\n}\n\n.why-netzsync-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.why-netzsync-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-align: center;\n  color: #1e293b;\n  margin-bottom: 3rem;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.feature-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 0.75rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: box-shadow 0.3s ease;\n}\n\n.feature-card:hover {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.feature-icon {\n  width: 4rem;\n  height: 4rem;\n  background: #2563eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  color: white;\n  font-size: 1.5rem;\n}\n\n.feature-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n}\n\n.feature-description {\n  color: #64748b;\n  line-height: 1.6;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .why-netzsync {\n    padding: 3rem 0;\n  }\n\n  .why-netzsync-title {\n    font-size: 2rem;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .feature-card {\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
